import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConfigurationService } from '../../shared/configuration.service';
import { LocalStorage } from '../../shared/localstorage.service';

import { PacketDetails } from '../../shared/configuration.model';

@Component({
  selector: 'app-packet-deductions-chart',
  templateUrl: './packet-deductions-chart.component.html',
  styleUrls: ['./packet-deductions-chart.component.scss'],
})
export class PacketDeductionsChartComponent implements OnInit {
    private getPackagesSubscription: Subscription;

    public packetsForStacked = [];
    public distinctQuestionsObject = {};

    constructor(
        private LocalStorage: LocalStorage,
        private ConfigurationService: ConfigurationService,
    ) {}

    ngOnInit() {
        this.getPackagesSubscription = this.ConfigurationService.getPackages(this.LocalStorage.getItem('currentState')).subscribe((packets: PacketDetails[]) => {
            packets.forEach((packet: PacketDetails) => {
                this.ConfigurationService.getPacketDeductionCountsOfThisMonth(packet.ID, this.LocalStorage.getItem('currentState')).subscribe(response => {
                    const packetToPush = {
                        name : packet.Name,
                    };

                    response.json().forEach(errorCount => {
                        this.distinctQuestionsObject[errorCount.questionText] = true;
                        packetToPush[errorCount.questionText] = errorCount.count;
                    });

                    this.packetsForStacked.push(packetToPush);
                })
            })
        })
    }

    ngOnDestroy() {
        this.getPackagesSubscription.unsubscribe();
    }

    public customizeTooltip = (arg: any) => {
        return {text: `<b>${arg.value}</b>  -  ${arg.seriesName}`};
    }

    public customizeLegendText = (arg: any) => {
        return this.textTruncate(arg.seriesName);
    }

    private textTruncate = (text: string, givenLength?: number) => {
        const maxLength = givenLength || 60;

        return text.length > maxLength ? text.substr(0, (maxLength - 4 >= 0 ? maxLength - 4 : 0)) + '...' : text
    }
}
